export enum FieldType {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  DateTime = 'DateTime',
  TextArea = 'TextArea',
  Email = 'Email',
  Phone = 'Phone',
  Name = 'Name'
}
